import store from "@/store";
import getUserSessionData from "@/functions/getUserSessionData";
import {handleActionClick} from "./handleActionClick";
import DepService from "@/api/services/depService";
import {setAuthToken} from "@/functions/authTokenStorage";
import {handleMyBundleEntry, isMyBundleEntry} from "@/functions/myBundleEntry";

export async function userAuthenticate(to, from, next) {
    if (isMyBundleEntry()) return await myBundleEntryFlow(to, from, next);

    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('e-msisdn') ?? urlParams.get('encryptedMsisdn');

    if (encryptedMsisdn && !urlParams.get('msisdn')) {
        try {
            const response = await DepService.decryptMsisdn(encryptedMsisdn);

            if (response.token) setAuthToken(response.token);

            const msisdn = response.msisdn;

            if (msisdn) {
                localStorage.setItem('msisdn', msisdn);
                store.commit('setMsisdn', msisdn);
                store.commit('setEncryptedMsisdn', encryptedMsisdn);
            }
        } catch (error) {
            console.error('Failed to decrypt msisdn', error);
        }
    }

    await userAuthenticateNormalFlow(to, from, next);
}

async function myBundleEntryFlow(to, from, next) {
    store.commit('setIsLoading', true);

    const entry = await handleMyBundleEntry();

    store.commit('setIsLoading', false);

    if (!entry.entered) return next({name: 'login'});
    if (entry.user.username === null) return next({name: 'username'});

    return next();
}

async function userAuthenticateNormalFlow(to, from, next) {
    store.commit('setIsLoading', true);

    if (checkUserState(to)) {
        store.commit('setIsLoading', false);

        return next();
    } else {
        const userSessionData = getUserSessionData();

        if (userSessionData.msisdn) await setUserData(userSessionData.msisdn, userSessionData.serviceId, next);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
    const googleClickId = urlParams.get('gclid');
    const clickId = urlParams.get('clickId');
    const msisdn = urlParams.get('msisdn') ?? localStorage.getItem('msisdn');

    if (!msisdn || !store.state.msisdn) {
        store.commit('setIsLoading', false);

        return next({name: 'login'});
    }

    if (!store.state.user) await redirectBasedOnUserStatus(next)
    if (campaignId) setCampaignId(campaignId)
    if (googleClickId) setGoogleClickId(googleClickId)
    if (clickId) setClickId(clickId)

    store.commit('setIsLoading', false);
    return next();
}

function setCampaignId(campaignId) {
    store.commit('setCampaignId', campaignId);
}

function setGoogleClickId(googleClickId) {
    store.commit('setGoogleClickId', googleClickId);
}

function setClickId(clickId) {
    store.commit('setClickId', clickId);
}

async function redirectBasedOnUserStatus(next) {
    const userResponse = (await DepService.getUserViaProductId(store.state.msisdn, store.state.productId)).data.user;

    store.commit('setUser', userResponse);
    store.commit('setIsLoading', false);

    if (!userResponse) return next({name: 'login'});
    if (userResponse.username === null) return next({name: 'username'});
}

function checkUserState(to) {
    const publicRoutes = ['login', 'terms', 'spotify-callback'];

    if (store.state.user || publicRoutes.includes(to.name)) return true
    else return false
}

async function setUserData(msisdn, serviceId, next) {
    store.commit('setMsisdn', msisdn);
    store.commit('setServiceId', serviceId);

    const user = (await DepService.getUserViaProductId(store.state.msisdn, store.state.productId)).data.user;

    store.commit('setUser', user);
    store.commit('setIsLoading', false);

    next();
}
